module.exports = __webpack_public_path__ + "static/profil-187_optimized-37b7c00408ce5de0ff681e92f14f77d6.jpg";